import {Directive, Input, TemplateRef} from '@angular/core';
import {BaseButtonComponent} from '@aviary/buttons/base/base-button.component';

@Directive()
export abstract class RoundButtonComponent extends BaseButtonComponent {
  // If defined, this content replaces the standard content while preserving the button itself and its behavior.
  @Input() public customContentTemplate?: TemplateRef<unknown>;

  @Input() public icon?: string;
  @Input() public iconClasses?: string;
  @Input() public iconOutlined: boolean = true;

  @Input() public buttonClasses: string = '';

  @Input() public ariaLabel?: string;

  public get computedAriaLabel(): string | null {
    return this.ariaLabel || this.tooltip || null;
  }
}
